import { render, staticRenderFns } from "./VeJwQingkaoList.vue?vue&type=template&id=2219e130&scoped=true"
import script from "./VeJwQingkaoList.vue?vue&type=script&lang=js"
export * from "./VeJwQingkaoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2219e130",
  null
  
)

export default component.exports